import {Component, ElementRef, NgZone, OnInit, ViewChild} from '@angular/core';
import {MapsAPILoader} from '@agm/core';
import {BranchRelation} from '../../models/branchrelation.model';
import {NearByPromosService} from '../../services/nearbypromos.service';
import {NearByPromo} from '../../models/nearbypromo.model';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-near-promos',
  templateUrl: './near-promos.component.html',
  styleUrls: ['./near-promos.component.css']
})
export class NearPromosComponent implements OnInit {

  title: string = 'AGM project';

  latitude: number = 0;
  longitude: number = 0;
  zoom: number;
  address: string;

  branches : NearByPromo[] = [];

  lastPage: number;
  selectedCardId: number;

  private geoCoder;

  // @ts-ignore
  @ViewChild('search')
  public searchElementRef: ElementRef;

  @ViewChild('mapContainer') gmap: ElementRef;
  map: google.maps.Map;

  coordinates = new google.maps.LatLng(this.latitude, this.longitude);

  mapOptions: google.maps.MapOptions = {
    center: this.coordinates,
    zoom: 8
  };

  marker = new google.maps.Marker({
    position: this.coordinates,
    map: this.map,
    title: 'Marker 0'
  });
  markers = [];

  showMap: boolean = false;


  constructor(

    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private nearByPromosService: NearByPromosService,
    private router: Router,
    private route: ActivatedRoute

  ) { }



  ngOnInit() {

    var idCard = this.route.snapshot.params['cardId'];
    this.lastPage = this.route.snapshot.params['page'];

    if(this.lastPage===undefined){
      this.lastPage=1;
    }

    this.selectedCardId = idCard;

    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;
    });

  }



  mapInitializer() {

    var bounds = new google.maps.LatLngBounds();
    var contSucs = 0;

    this.nearByPromosService.getNearByPromoBranches(this.selectedCardId, this.latitude, this.longitude).subscribe((branches : NearByPromo[]) => {

      this.nearByPromosService.setNearByPromoBranches(branches);
      this.branches = branches;


      this.branches.forEach( (branch: NearByPromo) => {
        bounds.extend(new google.maps.LatLng(Number(branch.latitud), Number(branch.longitud)));
        contSucs++;
      });

      bounds.extend(new google.maps.LatLng(Number(this.latitude), Number(this.longitude)));

      let currentLoc = new NearByPromo(0, 'Mi ubicación actual', 0, '', this.latitude, this.longitude, this.address, '', '', '', '', '');

      this.branches.push(currentLoc);

      //console.log('Cont SUCS: ' + contSucs);

      this.map = new google.maps.Map(this.gmap.nativeElement);
      this.map.fitBounds(bounds);

      this.loadMarkers(this.branches);

    });

  }

  loadMarkers(sucs: NearByPromo[]) {

    sucs.forEach(branch => {


       let marker = new google.maps.Marker({
        position: new google.maps.LatLng(Number(branch.latitud), Number(branch.longitud)),
        map: this.map
       });

      const infoWindow = new google.maps.InfoWindow({
        // content: '<center><b>' + branch.nombre + '</b></center><br>' + branch.direccion + ', ' + branch.codigoPostal + ', ' + branch.ciudad
        content: '<center><b>' + branch.nombre + '</b></center>'
      });

      if(branch.idComercio!=0){
         marker.setIcon('https://promocionesbancoppel.com/pub/commerce_icon_32.png');
        infoWindow.open(marker.getMap(), marker);
      }
      /*else{
        infoWindow.open(marker.getMap(), marker);
      }*/

      //creating a new info window with markers info


      //Add click event to open info window on marker
      //marker.addListener('click', () => {
      marker.addListener('mouseover', () => {
        infoWindow.open(marker.getMap(), marker);
      });
      marker.addListener('click', () => {
        infoWindow.open(marker.getMap(), marker);
      });

      // assuming you also want to hide the infowindow when user mouses-out
      marker.addListener('mouseout', function () {
        infoWindow.close();
      });

      //Adding marker to google maps
      marker.setMap(this.map);

    });

  }



  private setCurrentLocation() {

    if ('geolocation' in navigator) {

      navigator.geolocation.getCurrentPosition((position) => {

        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 8;
        this.getAddress(this.latitude, this.longitude);

        //console.log('Initializing map');
        this.showMap=true;

      });

    }

  }



  getAddress(latitude, longitude) {

    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {

      if (status === 'OK') {

        if (results[0]) {
          this.zoom = 12;
          this.address = results[0].formatted_address;

        } else {

          window.alert('No results found');
        }

      } else {

        window.alert('Geocoder failed due to: ' + status);
      }

      this.mapInitializer();

    });

  }

}
